import HeroCarousel from "./components/HeroCarousel";
import CategoryCards from "./components/CategoryCards";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import NewsSection from "./components/NewsSection";
import IntroSection from "./components/IntroSection";

export default function Home() {
  return (
    <div className="w-full pb-14 md:pb-20 animate-fade-in">
      <HeroCarousel />
      <CategoryCards />
      <LatestSection />
      <RankingSection />
      <NewsSection />
      <IntroSection />
    </div>
  );
}